module.exports = __webpack_public_path__ + "static/img/top_case.b8561e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/top_case.png
// module id = 4MSm
// module chunks = 1